import * as React from "react";
import { styled } from "styled-components";
import { FormOption } from "../../components/ContactForm/ContactForm.js";
import { CheckBox } from "./Checkbox.js";

interface CheckboxGroupProps {
  label: string;
  onChange: (fieldName: string, checked: boolean) => void;
  options: FormOption[];
  data: any;
  required: boolean;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  label,
  options = [],
  onChange,
  data,
  required,
}) => {
  const hasValue = options.some((f) => data[f.name!] === true);
  const firstInputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    const input = firstInputRef.current;

    if (input) {
      const validationMessage =
        required && !hasValue ? "Du må velge minst ett alternativ." : "";

      input.setCustomValidity(validationMessage);
    }
  }, [required, hasValue]);

  return (
    <Fieldset>
      <Legend>
        {label} {required && " *"}
        {required && (
          <span className="b1">Du må velge minst ett alternativ.</span>
        )}
      </Legend>
      {options.map((o, index) => (
        <CheckBox
          key={o.value}
          label={o.label}
          ref={index === 0 ? firstInputRef : null}
          name={o.name}
          required={required && !hasValue}
          checked={data[o.name!]}
          onChange={(e) => onChange(o.name!, e.target.checked)}
        />
      ))}
    </Fieldset>
  );
};

const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

const Legend = styled.legend`
  display: block;
  margin-bottom: ${(props) => props.theme.spacing.xs};
  font-weight: 600;

  span {
    display: block;
    font-size: 0.85rem;
  }
`;
